export * from './unit-conversion';
export * from './unit-symbol';
export * from './unit-system';
export * from './unit-type';
export * from './utils';

export type Unit = keyof typeof UnitRegistry;

export const UnitRegistry = {
  absolute: {
    name: 'absolute',
    baseFactor: 1,
    symbol: null,
  },
  percent: {
    name: 'percent',
    baseFactor: 100, // Base unit is [0, 1]
    symbol: '%',
  },

  // ***** Duration ***** //

  'HH:mm:ss': {
    name: 'HH:mm:ss',
    baseFactor: 1,
    symbol: null,
  },
  'HH:mm': {
    name: 'HH:mm',
    baseFactor: 1,
    symbol: null,
  },

  // ***** Length ***** //

  in: {
    name: 'inches',
    baseFactor: 39.37007874,
    symbol: 'in',
  },
  m: {
    name: 'meters',
    baseFactor: 1,
    symbol: 'm',
  },
  ft: {
    name: 'feet',
    baseFactor: 3.280839895,
    symbol: 'ft',
  },
  mi: {
    name: 'miles',
    baseFactor: 0.000621371192,
    symbol: 'mi',
  },
  cm: {
    name: 'centimeters',
    baseFactor: 100,
    symbol: 'cm',
  },
  km: {
    name: 'kilometers',
    baseFactor: 0.001,
    symbol: 'km',
  },

  // ***** Weight ***** //

  kg: {
    name: 'kilograms',
    baseFactor: 1,
    symbol: 'kg',
  },
  lbs: {
    name: 'pounds',
    baseFactor: 2.20462262185,
    symbol: 'lbs',
  },
} as const satisfies Record<string, UnitDefinition>;

export interface UnitDefinition {
  /** The name of the unit. */
  name: string;
  /** The factor to convert the base unit to this unit. */
  baseFactor: number;
  /** The symbol of the unit. */
  symbol: string | null;
}
